module.exports = __webpack_public_path__ + "img/label_d.3b46b31b.svg";